/*
 * cmn.js
 */

// import jQuery from 'jquery';  //node_modlesの中にあるものを使用探しに行ってくれる
import $ from 'jquery';
import 'jquery.cookie';
import 'slick-carousel';
import '../scss/style.scss';
import './mainvisual.js';

$(function(){
/* ==========================================================
!stack
========================================================== */
/* 関数の読み込み
------------------------------------ */
	toggleMenu();
	pageTop();
	pageTopFixed();
	pageScroll();
	Accordion();
	tabMenu();
	scrollAnimation();
	closeFixBanner();
	telLink();

/* スライダー系処理
-------------------------------------------------- */
	$('.js-carousel').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow:2,
				}
			}
		]
	});

	$('.js-slide01').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: '.js-slide01-tumbs'
	});
	$('.js-slide01-tumbs').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: '.js-slide01',
		dots: false,
		arrows: true,
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
					variableWidth: true,
				}
			}
		]
	});

	$('.js-fade-slider01').slick({
		autoplay: true,
		speed: 3000,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
	});

	$('.js-midslider').slick({
		autoplay: true,
		autoplaySpeed: 0,
		speed: 20000,
		cssEase: "linear",
		slidesToShow: 1.8,
		swipe: false,
		arrows: false,
		pauseOnFocus: false,
		pauseOnHover: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 0.7,
				}
			}
		]
	});

/* フォームファイル処理
-------------------------------------------------- */

	$('.attachment .fileinput').on('change', function () {
	 var file = $(this).prop('files')[0];
		 $(this).closest('.attachment').find('.filename').text(file.name);
	});

/* フォームプライバシー処理
-------------------------------------------------- */

	var privacy = $('.privacyInput');
	var sendbutton = $('.submitBtn');
	sendbutton.prop("disabled", true).addClass('disabled');
	if (privacy.is(':checked')) {
		// ボタンを有効化
		sendbutton.prop('disabled', false).removeClass('disabled');
	} else {
		// ボタンを無効化
		sendbutton.prop("disabled", true).addClass('disabled');
	}
	privacy.change(function() {
		if (privacy.is(':checked') ){
			// ボタンを有効化
			sendbutton.prop('disabled', false).removeClass('disabled');
		} else {
			// ボタンを無効化
			sendbutton.prop("disabled", true).addClass('disabled');
		}
	});

});


/* 新卒採用MV処理
-------------------------------------------------- */
$(window).on("load", function () {
	if($(".p-recruit-new-mv").length){

		if ($.cookie('newMv_flg') != 1) {
			setTimeout(function(){
				$(".p-recruit-new-mv .is-mask").addClass("is-on");
				setTimeout(function(){
					$(".p-recruit-new-mv").addClass("is-on");
					$(".p-recruit-new-mv .is-mask").removeClass("is-on");
					$(".p-recruit-new-mv .is-nonmask").addClass("is-on");
					setTimeout(function(){
						$(".p-recruit-new-mv").addClass("is-hide");
						setTimeout(function(){
							$(".p-recruit-new-mv").remove();
							setTimeout(function(){
								var ww = $(window).width();
								if (window.matchMedia("(max-width:767px)").matches) {
									var moveWidth = 1440 - ww;
								} else {
									var moveWidth = 2700 - ww;
								}
								//console.log(moveWidth);
								$(".js-slide-mv img").css('transform', 'translateX(-' + moveWidth + 'px)');
								$.cookie('newMv_flg', 1, { expires: 1 });
							}, 300);
						}, 1500);
					}, 1500);
				}, 1500);
			}, 1000);
		} else {
			$(".p-recruit-new-mv").remove();
		}

	}
});

/* 中途採用MV処理
-------------------------------------------------- */
$(window).on("load", function () {
	if($(".p-recruit-mid-mv").length){
		if ($.cookie('midMv_flg') != 1) {
			setTimeout(function(){
				$(".p-recruit-mid-mv .is-mask").addClass("is-on");
				setTimeout(function(){
					$(".p-recruit-mid-mv").addClass("is-on");
					$(".p-recruit-mid-mv .is-mask").removeClass("is-on");
					$(".p-recruit-mid-mv .is-nonmask").addClass("is-on");
					setTimeout(function(){
						$(".p-recruit-mid-mv").addClass("is-hide");
						setTimeout(function(){
							$(".p-recruit-mid-mv").remove();
							setTimeout(function(){
								$(".mid-video").get(0).play();
								$.cookie('midMv_flg', 1, { expires: 1 });
							}, 200);
						}, 1500);
					}, 1500);
				}, 1500);
			}, 1000);
		} else {
			$(".p-recruit-mid-mv").remove();
			$(".mid-video").get(0).play();
		}
	}
});

/* アンカー付きページ移動処理
-------------------------------------------------- */
$(window).on("load", function () {
	const hash = location.hash; //ハッシュを取得
	console.log(hash);
	/* window.matchMedia
	------------------------------------ */
	if (window.matchMedia("(max-width:767px)").matches) {
		// (1)windowの読み込みが完了したときに、767px以下の場合に行いたいもの
		if($(hash).length) {
			$("html, body").animate({
				scrollTop: $(hash).offset().top - 80,
			},500);
		}

	} else {
		// (2)windowの読み込みが完了したときに、768px以上の場合に行いたいもの
		if($(hash).length) {
			$("html, body").animate({
				scrollTop: $(hash).offset().top - 120,
			},500);
		}

	}
});

/* グロナビ処理
-------------------------------------------------- */

//変数初期化
var pos = 0;
//スクロールが発生した際に実行
$(window).on('scroll', function(){
	//ユーザーのスクロール位置取得　& スクロール方向で分岐
	if($(this).scrollTop() < pos ){
		//上スクロール時の処理を記述
		$("body").removeClass("is-scroll-down").addClass("is-sroll-up");
		if($(this).scrollTop() < 150){
			$("body").removeClass("is-sroll-up");
		}
	}else{
		//下スクロール時の処理を記述
		$("body").removeClass("is-sroll-up").addClass("is-scroll-down");
	}
	//スクロールが停止した位置を保持
	pos = $(this).scrollTop();
});


/* グローバル */
const pointSPHeader = window.matchMedia('screen and (max-width: 959px)');
let beforePos = 0;

/* toggleMenu
-------------------------------------------------- */
const toggleMenu = function(){
	const $toggleBtn = $('.l-menu-trigger');
	const $toggleMenu = $('#' + $toggleBtn.attr('aria-controls'));
	const $body = $('body');
	let w = $(window).width();
	let scrollpos = 0;

	$toggleBtn.on('click',function(){
		let expanded = $(this).attr('aria-expanded');
		// console.log(expanded);
		if(expanded == 'false') {
			openMenu();
		}else {
			closeMenu();
		}
	});

	function openMenu() {
		scrollpos = $(window).scrollTop();
		// console.log(scrollpos);
		$toggleMenu.attr('aria-hidden','false').fadeIn();
		$toggleBtn.attr('aria-expanded','true');
		$body.addClass('nav-open').css({"top": -scrollpos});
		
	}
	function closeMenu() {
		$toggleMenu.attr('aria-hidden','true').fadeOut();
		$toggleBtn.attr('aria-expanded','false');
		$body.removeClass('nav-open').css({"top": 0});
		$('html, body').animate({scrollTop:scrollpos},0);
	}
	function resetMenu() {
		$toggleBtn.attr('aria-expanded','false');
		$body.removeClass('nav-open').css({"top": 0});
		$('html, body').animate({scrollTop:scrollpos},0);
		// $toggleMenu.attr('aria-hidden','true').hide();
		$toggleMenu.removeAttr('aria-hidden').show();
	}

	function checkBreakPoint() {
		if (!pointSPHeader.matches) {
			resetMenu();
		}else {
			closeMenu();
		}
	}
	if(w < 945){
		closeMenu();
	}

	pointSPHeader.addListener(checkBreakPoint);
}

/* ==========================================================
!pageTop
========================================================== */
const pageTop = function () {
	$(".pagetop").click(function () {
		$("html, body").animate({ scrollTop: 0 }, 1000, "easeInOutCubic");
		return false;
	});
};
/* ==========================================================
!fixed pagetop scroll
========================================================== */
const pageTopFixed = function () {
	const pageTopBox = $(".pagetop_fixed");
	const pageTopLink = $(".pagetop_fixed p");

	pageTopLink.click(function () {
		$("html, body").animate({ scrollTop: 0 }, 1000, "easeInOutCubic");
		return false;
	});

	$(window).on("scroll", function () {
		if ($(this).scrollTop() > 150) {
			pageTopBox.fadeIn();
		} else {
			pageTopBox.fadeOut();
		}

		const scrollHeight = $(document).height();
		const scrollPosition = $(window).height() + $(window).scrollTop();
		const footHeight = $("#footer").innerHeight();
		if (scrollHeight - scrollPosition <= footHeight) {
			pageTopLink.css({ position: "absolute", bottom: "0px" });
		} else {
			pageTopLink.css({ position: "fixed", bottom: "0px" });
		}
	});
};
/* ==========================================================
!pageScroll
========================================================== */
const pageScroll = function () {
	// jQuery.easing.easeInOutCubic = function (x, t, b, c, d) {
	// 	if ((t /= d / 2) < 1) return (c / 2) * t * t * t + b;
	// 	return (c / 2) * ((t -= 2) * t * t + 2) + b;
	// };
	$("a[href*='#']:not('.inline'), .scroll").click(function () {
		$("html, body").animate(
			{
				scrollTop: $($.attr(this, "href")).offset().top - 120, // - 70 等といれるとそのピクセル数分増えた状態でスクロールが止まる(ヘッダー固定の時に利用)
			},
			500
		);
		return false;
	});
};
/* ==========================================================
!Accordion
========================================================== */
const Accordion = function () {
	const accordion01 = $(".accordion dt");

	// クリックしたとき
	accordion01.on("click", function () {
		$(this).toggleClass("active").next().slideToggle();
	});

	// エンターキーを押したとき
	accordion01.on("keyup", function (e) {
		if (e.keyCode == 13) {
			$(this).toggleClass("active").next().slideToggle();
		}
	});

	/* window.matchMedia
	------------------------------------ */
	if (window.matchMedia("(max-width:767px)").matches) {
		// (1)windowの読み込みが完了したときに、767px以下の場合に行いたいもの


	} else {
		// (2)windowの読み込みが完了したときに、768px以上の場合に行いたいもの


	}

	function matchFunction() {
		// (3)windowサイズを変更して、767px以下になったら発火するイベント


		if (window.matchMedia("(min-width:768px)").matches) {
			// (4)windowサイズを変更して、768px以上になったら発火するイベント


		}
	}
	window.matchMedia("(max-width:768px)").addListener(matchFunction);

};
/* ==========================================================
!tab
========================================================== */
const tabMenu = function () {
	const tabLink = $("#tab_link li a");
	tabLink.on("click", function () {
		$("#tab_contents > div").hide();
		$($(this).attr("href")).fadeToggle();
	});
};
/* ==========================================================
!Scroll Animation
========================================================== */
const scrollAnimation = function () {
	const AnimTrigger = $(".effect"); //アニメーショントリガー
	const windowHeight = $(window).height(); //ウインドウの高さ

	// ロードした際に可視範囲に入っていたら実行される
	$(window).on("load", function () {
		AnimTrigger.each(function () {
			const imgPos = $(this).offset().top; //「AnimTrigger」の位置

			if (imgPos < windowHeight) {
				$(this).addClass("aniOn");
			}
		});
	});

	// スクロールした際に「AnimTrigger」ごとに、以下に記述する内容が実行される
	$(window).scroll(function () {
		const scroll = $(window).scrollTop(); //スクロールした量

		AnimTrigger.each(function () {
			const imgPos = $(this).offset().top; //「AnimTrigger」の位置

			//アニメーションする条件＝「画面の下から1/5まできた時点でアニメーション」
			if (scroll > imgPos - windowHeight + windowHeight / 5) {
				//スクロール量　が次の条件より多いとき　…　条件：トリガーの場所　引く　ウィンドウの高さ　足す　ウィンドウの高さ　割る　5（- windowHeight + windowHeight / 5 なので6/5でなく4/5）
				$(this).addClass("aniOn");
			}
		});
	});
};


/* ==========================================================
!Close banner
========================================================== */
const closeFixBanner = function () {
	const fixBanner = $('.p-fix-banner');
	const fixBannerCloseBtn = $('.p-fix-banner__close');

	if ($.cookie('bnr_flg') != 1) {
		fixBanner.addClass('is-visible');
	}

	if (fixBanner.length) {
		fixBannerCloseBtn.on('click',function() {
			$.cookie('bnr_flg', 1, { expires: 1 });
			fixBanner.fadeOut();
			fixBanner.addClass('is-hide');
		});
	}
}

/* ==========================================================
!Tel Link
========================================================== */
const telLink = function() {
	var ua = navigator.userAgent;
	if(ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0){
		$('.js-tel-link').each(function(){
			var str = $(this).text();
			$(this).html($('<a>').attr('href', 'tel:' + str.replace(/-/g, '')).append(str + '</a>'));
		});
	}
}
